import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { DialogComparateurComponent } from 'src/app/views/dialogs/dialog-comparateur/comparateur.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(
    private cdf: ChangeDetectorRef,
    private dialog: MatDialog
  ) { }

  @Input() paddingValues;
  @Input() hasComparateur;
  @Input() addDossier: Observable<any>;
  @Input() removeDossier: Observable<any>;
  @Input() updateDossier: Observable<any>;

  showComparaison = false;
  comparateurError = null;
  isComparateurOpened = false;

  addDossierSubscription: Subscription;
  removeDossierSubscription: Subscription;
  updateDossierSubscription: Subscription;
  dossiersToCompare: Array<any> = [];

  ngOnInit() {
    let dossiers = JSON.parse(localStorage.getItem("dossiersComparaison"));
    this.dossiersToCompare = dossiers ? dossiers : [];
    this.addDossierSubscription = this.addDossier ? this.addDossier.subscribe((dossier) => {
      this.addToComparaison(dossier);
    }) : null;
    this.removeDossierSubscription = this.removeDossier ? this.removeDossier.subscribe((dossier) => {
      this.removeFromComparaisonWithDossier(dossier);
    }) : null;
    this.updateDossierSubscription = this.updateDossier ? this.updateDossier.subscribe((dossier) => {
      this.updateDossierComparaison(dossier);
    }) : null;
  }

  createPseudoDossier(dossier)
  {
    return {
      "id": dossier.id,
      "entreprise": dossier.entreprise,
      "nom": dossier.nom,
      "prenom": dossier.prenom,
      "date": dossier.datemodification ? dossier.datemodification : dossier.datecreation,
      "motif": dossier.motifsortie_label,
      "dossier_libelle": dossier.dossier_label
    };
  }

  addToComparaison(dossier) 
  {
    if (this.dossiersToCompare.length > 2) {
      this.showComparateurError("Impossible d'ajouter un 4ème dossier.");
    } else {
      let isPresent = false;
      this.dossiersToCompare.map( (doss) => {
        if (doss.id == dossier.id) {
          isPresent = true;
        }
      })
      this.showComparaison = true;
      if (!isPresent) {
        this.dossiersToCompare.push(this.createPseudoDossier(dossier));
        this.saveInLocalStorage();
        this.cdf.detectChanges();
      }
    }
  }


  removeFromComparaisonWithDossier(dossier)
  {
    let index;
    this.dossiersToCompare.map((e, i) => {
      if (dossier.id == e.id) {
        index = i;
      } 
    });
    if (index >= 0) {
      this.dossiersToCompare.splice(index, 1);
      this.saveInLocalStorage();
      this.cdf.detectChanges();
    }
  }

  removeFromComparaison(index)
  {
    this.dossiersToCompare.splice(index, 1);
    this.saveInLocalStorage();
    this.cdf.detectChanges();
  }

  removeAllDossiersComparaison()
  {
    this.dossiersToCompare = [];
    this.saveInLocalStorage();
  }

  updateDossierComparaison(dossier){
    const idxComparaison =  this.dossiersToCompare.findIndex((d)=>d.id == dossier.id);
    if(idxComparaison>=0){
      this.dossiersToCompare[idxComparaison] = this.createPseudoDossier(dossier);
      this.saveInLocalStorage();
      this.cdf.detectChanges();
    }
  }

  saveInLocalStorage() 
  {
    localStorage.setItem("dossiersComparaison", JSON.stringify(this.dossiersToCompare));
  }

  showComparateurError(error)
  {
    this.showComparaison = true;
    this.comparateurError = error;
    setTimeout(() => {
      this.comparateurError = null;
      this.cdf.detectChanges();
    }, 5000);
  }

  openComparateur()
  {
    if (!this.isComparateurOpened) {
      this.showComparaison = false;
      const dialogRef = this.dialog.open(DialogComparateurComponent, {
        width: '100%',
        maxWidth:'100%',
        data: { "dossiersId": this.dossiersToCompare.map((x) => x.id) }
      });
      dialogRef.afterOpened().subscribe(() => {
        this.isComparateurOpened = true;
      })
      dialogRef.afterClosed().subscribe(() => {
        this.isComparateurOpened = false;
      })
    }
  }
}
